import React, { Component } from 'react'
import { connect } from 'react-redux'

import { dirtyRead, doc } from 'selectors/common'

import FormHeader from 'components/FormHeader'
import FormFooter from 'components/FormFooter'
import Deleted from 'components/Deleted'
import Divider from 'material-ui/Divider'

import LeftSide from './LeftSide'
import RightSide from './RightSide'

let select = dirtyRead(
	(state, props) => {
		return {
			owner: doc(state, props.routeParams.id)
		}
	}
)

export class Profile extends Component{
	render(){
		let { props } = this
		let ownerID = props.routeParams.id
		return(
			<div
				style={{
					display: "inline-block"
				  , width: "100%"
				  , overflow: "hidden"
				}}
			>
				<FormHeader
					title={"Profile"}
					masterDetail={false}
					objectID={ownerID}
				/>
				{(!props.owner)?
					<Deleted />
					:
					<div style={{position:"relative", height:"calc(100vh - 64px)", overflowX: "hidden"}}>
						<main style={{height:"calc(100vh - 64px)", display: "flex"}}>
			  				<LeftSide ownerID={ownerID} query={props.location.query}/>
							<Divider style={{marginTop: "20px"}}/>
							<RightSide ownerID={ownerID} />
						</main>
						<div
							style={{
								position:"fixed"
						      , zIndex:"9999"
							  , bottom:"3px"
							  , right:"17px"
							  , boxSizing: "borderBox"
							  , maringRight: "17px"
							}}
						>
							<FormFooter
								objectID={ownerID}
								masterDetail={false}
								cancel={true}
							/>
						</div>
					</div>
				}
			</div>
		)
	}
}

export default connect(select)(Profile)



// WEBPACK FOOTER //
// ./src/routes/landlord/profile/index.js